





















































































































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Node, InlineCss } from '../types';
import { SwQsgModal, SwQsgModalBody } from './sw-qsg-modal';

const cssPrefix = 'sw-quick-start-guide-node';

@Component({
  components: {
    SwQsgModal,
    SwQsgModalBody,
  },
})
export default class SwQuickStartGuideNode extends SwExtendedVue {

  cssPrefix = cssPrefix;
  multimediaModal: boolean = false;
  multimediaSourceName: string = '';
  multimediaWidth: string | undefined = '';
  customTick: number = 0;

  @Prop({ type: Array, required: true })
  nodes: Node[];

  get elementPosition() {
    let inlineCss: InlineCss = {};  // tslint:disable-line
    return (node: any) => {
      if (node.node_element && document.getElementsByClassName(node.node_element).length > 0) { // tslint:disable-line
        const elementBounding: any = document.getElementsByClassName(node.node_element)[0]
        .getBoundingClientRect();
        // console.warn(elementBounding);
        return inlineCss = {
          width: elementBounding.width ? `${elementBounding.width}px` : 'auto',
          height: elementBounding.height ? `${elementBounding.height}px` : 'auto',
          left: elementBounding.left ? `${elementBounding.left}px` : 'auto',
          top: elementBounding.top ? `${elementBounding.top}px` : 'auto',
          right: 'auto',
        };
      } else if (node.node_element === '' && Object.keys(node.inline_css).length > 0) { // tslint:disable-line
        return inlineCss = {};
      } else if (Object.keys(node.inline_css).length === 0) { // tslint:disable-line
        return inlineCss = { display: 'none' };
      }
    };
  }

  openModal(multimedia: any) {
    // this.multimediaSource = this.mediaPath(multimedia.video_path);
    // this.multimediaSource = `../assets/${multimedia.video_path}`;
    this.multimediaSourceName = multimedia.video_path || '';
    this.multimediaWidth = multimedia.video_position.inline_css ? multimedia.video_position.inline_css.width : 'auto';
    this.multimediaModal = true;
  }
  /*
    multimediaSource(): any {
      return this.mediaPath(multimedia.video_path);
    }
  */
  mounted() {
    setTimeout(() => {
      for (let i = 0; i <= this.nodes.length - 1; i = i + 1) { // tslint:disable-line
        if (this.nodes[i]['keyframe']['name']) {
          // this.keyframe(this.nodes[i]['keyframe']);
          this.keyframe(this.nodes[i]);
        }
      }
    }, 50); // tslint:disable-line
  }
  /*
  nodeAnimate(data: Node) {
    const inlineCss: any = {};
    for (const css in data.node_animate_css) {
      if (data.node_animate_css[css].trim()) {
        const pos = css.lastIndexOf('_bc');
        if (pos === -1) {
          inlineCss[css.replace(/_/g, '-')] = data.node_animate_css[css];
        } else {
          inlineCss[css.replace('_bc', '')
            .replace(/_/g, '-')] = data.node_animate_css[css];
        }
      }
    }
    return inlineCss;
  }
  */
  nodeAnimate(data: Node) {
    const inlineCss: any = {};
    for (const css in data.node_animate_css) {
      if (css.trim()) {
        const pos = css.lastIndexOf('_bc');
        if (pos === -1) {
          inlineCss[css.replace(/_/g, '-')] = data.node_animate_css[css];
        } else {
          inlineCss[css.replace('_bc', '')
            .replace(/_/g, '-')] = data.node_animate_css[css];
        }
      }
    }
    return inlineCss;
  }

  keyframe(data: any) {
    if ((data.node_element && document.getElementsByClassName(data.node_element).length > 0) || data.node_id === 'node_close') {
      const styleElement: any = document.getElementById(data['keyframe']['name']);
      if (styleElement) {
        styleElement.remove();
      }
      const style = document.createElement('style');
      style.type = 'text/css';
      style.id = `${data['keyframe']['name']}`;
      // const browserKeyframes: any = ['@keyframes', '@-webkit-keyframes', '@-moz-keyframes'];
      let generatedStyle = '';
      generatedStyle += ' @keyframes';
      generatedStyle += ` ${data['keyframe']['name']} {`;
      for (let j = 0; j <= data['keyframe'].breakpoints.length - 1; j = j + 1) {    // range in percentage loop
        generatedStyle += ` ${data['keyframe'].breakpoints[j]['range']} {`;
        for (const pr in data['keyframe'].breakpoints[j]['properties']) {
          if (data['keyframe'].breakpoints[j]['properties'][pr] === 'getBoundingClientRect') {
            const elementBounding: any = document.getElementsByClassName(data.node_element)[0].getBoundingClientRect(); // tslint:disable-line
            generatedStyle += ` ${pr}: ${elementBounding.top}px;`;
          } else {
            generatedStyle += ` ${pr}: ${data['keyframe'].breakpoints[j]['properties'][pr]};`;
          }
        }
        generatedStyle += ' }';
      }
      generatedStyle += ' }';
      const generatedStyleCopy = generatedStyle;
      generatedStyle += `${generatedStyle.replace('@keyframes', '@-webkit-keyframes')} ${generatedStyleCopy.replace('@keyframes', '@-moz-keyframes')}`;
      style.innerHTML = generatedStyle;
      document.getElementsByTagName('head')[0]
        .appendChild(style);

    }
    return '';
  }

  get mediaPath() {
    /*
    const assetsPath = '@/assets/images/quick-start-guide/';
    return (path: any) => { return `${assetsPath}${path}`; };
    */
    // const assetsPath = '/static/quick-start-guide/';     // To render the assets in local environment
    const assetsPath = '/workspace/static/quick-start-guide/';  // To render the assets in server
    return (path: string) => {
      if (path.includes('http') || path.includes('https')) {
        return `${path}`;
      }
      return `${assetsPath}${path}`;
    };
    // return (path: any) => { return require(`../assets/${path}`); };
  }

  scrollCorrection(nodes: Node[]) {
    // setTimeout(() => {
    const nodeTops: any = {};
    for (const node of nodes) {
      if (node.node_element && node.scroll_correction && document.getElementsByClassName(node.node_element)[0]) {
        /* document.getElementsByClassName(node.node_element)[0].scrollIntoView(); */ // tslint:disable-line
        let bounding = document.getElementsByClassName(node.node_element)[0].getBoundingClientRect();  // tslint:disable-line
        nodeTops[node.node_element] = bounding.top;
      }
    }
    if (Object.keys(nodeTops).length > 0) {
      const nodesSorted: any = Object.keys(nodeTops).sort(function(a, b) { return nodeTops[a] - nodeTops[b] });  // tslint:disable-line
      const scrollElement: any = nodesSorted[0];
      if (document.getElementsByClassName(scrollElement)[0]) {
        document.getElementsByClassName(scrollElement)[0].scrollIntoView(); // tslint:disable-line
      }
    }
    return {};
    // }, 50); // tslint:disable-line
  }

}
